import { render, staticRenderFns } from "./ReturnedPackage.vue?vue&type=template&id=205af720&"
import script from "./ReturnedPackage.vue?vue&type=script&lang=js&"
export * from "./ReturnedPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports